import { Event } from "../../../base/common/events.js";
import { createDecorator } from "../../instantiation/common/registry.js";


export const IWebGLService = createDecorator<IWebGLService>("webglService");

export interface WebGLServiceChangedEvent {
    readonly service: IWebGLService;
}

/**
 * Provides WebGL-related functionalities and manages available WebGL engines. E.g., Three.js, Babylon.js, etc.
 */
export interface IWebGLService {

    readonly onDidChange: Event<WebGLServiceChangedEvent>;

    registerEngine(engine: IWebGLEngine): void;
    hasEngine(name: WebGLEngineName): boolean;
    getEngine<T extends IWebGLEngine>(name: WebGLEngineName): T | undefined;
    getAllEngines(): IWebGLEngine[];

}


export type WebGLEngineName = "threejs" | "babylonjs";

export interface WebGLEngineChangedEvent {
    readonly engine: IWebGLEngine;
}

/**
 * Implement to provide WebGL engine access like Three.js, Babylon.js, etc.  
 */
export interface IWebGLEngine {
    readonly name: WebGLEngineName;
    readonly onDidChange: Event<WebGLEngineChangedEvent>;
    // connect(bridge: IWebGLSceneBridge): void;
    // disconnect(bridge: IWebGLSceneBridge): void;

    // registerRenderer?(renderer: unknown): void;
    getScene?<TScene = unknown>(): TScene | null;
    getRenderer?<TRenderer = unknown>(): TRenderer | null;
    getCamera?<TCamera = unknown>(): TCamera | null;
    
    getScenes?<TScene = unknown>(): TScene[] | null;
    
    findObjectById?(id: string): unknown | null;

    editorCamera?: boolean;
}
/**
 * Bridge interface to connect WebGL engines with the application/editor.
 */
// export interface IWebGLSceneBridge<
//     TCamera = unknown,
//     TScene = unknown,
//     TRenderer = unknown,
//     TRaycastResult = unknown,
//     TFitCameraResult = void,
// > {
//     getCamera?(): TCamera;
//     getScene?(): TScene;
//     getRenderer?(): TRenderer;
//     /** @deprecated */
//     raycast?(raycaster: unknown): TRaycastResult;
//     /** @deprecated */
//     fitCamera?(objects: unknown[]): TFitCameraResult;
// }
